module.exports = __webpack_public_path__ + "static/media/note.afc799c2.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/form/Type/note.svg
 ** module id = 194
 ** module chunks = 0
 **/